module.exports = __webpack_public_path__ + "static/img/banner2.3d20fd9b.jpg";